import './simplebar';
import Cookies from 'modules/Cookies';
import { isMobile, isMl3App, isiOS } from '../modules/DeviceOptions';
import { NativeInitGeoFence, getMl3AppVersion } from '../modules/Native'; // modules Native must be imported even if there is no usage in this maplifeCommon.entry.js
import './account';
import './createMap';
import './createSpot';
import './spotIcons';
import './login';
import './sns';
import './notification';
import './geoFenceSettings';
import './myMapList';

import { checkCurrentLocationIsOkinawa } from '../modules/Helpers';
import { versionCompare } from '../modules/Utils';

const setLatLngInCookie = async () => {
  try {
    const isInOkinawa = await checkCurrentLocationIsOkinawa();

    const expires = new Date(window.moment().add(1, 'hours'));
    Cookies.originalSet('isinokinawa', isInOkinawa ? '1' : '0', expires);
  } catch (e) {
    console.log(e);
  }
};

setTimeout(() => {
  if (isMobile) {
    setLatLngInCookie();

    setInterval(async () => {
      setLatLngInCookie();
    }, 10 * 1000);
  }
}, 0);

$(document).ready(async () => {
  setTimeout(() => {
    NativeInitGeoFence();
  }, 300);

  // check floating button
  if (isMl3App && isiOS) {
    const version = await getMl3AppVersion();
    if (versionCompare(version, '3.1.1') >= 0) {
      $('.iOSFloatingButton').addClass('enabled');

      let lastScrollTop = 0;
      window.addEventListener('scroll', () => {
        const st = window.pageYOffset || document.documentElement.scrollTop;
        if (st > lastScrollTop) {
          $('.iOSFloatingButton').addClass('hidden');
        } else {
          $('.iOSFloatingButton').removeClass('hidden');
        }

        // For Mobile or negative scrolling
        lastScrollTop = st <= 0 ? 0 : st;
      });
    }
  }
});
